import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { Col, Input, Row } from 'antd'

import ProductCategorySelector from '../../components/productCategorySelector'
import inquiryActions from '../../redux/inquiry/actions'

const {
    setSearchQuery,
    setItemQuery,
    setProductCategoryFilter
} = inquiryActions

class ItemFilters extends Component {
    handleSearchChange = (value) => {
        this.props.setItemQuery(value)
    }

    handleSearchInput = (value) => {
        this.props.setSearchQuery(value)
    }

    handleProductCategoryChange = (value) => {
        this.props.setProductCategoryFilter(value)
    }

    render () {
        const { i18n, inquiry } = this.props

        return (
            <Row gutter={12}>
                <Col xs={24} md={14}>
                    <Input.Search
                        placeholder="Search items"
                        onChange={(e) => this.handleSearchChange(e.target.value)}
                        onSearch={this.handleSearchInput}
                        style={{ width: '100%' }}
                    />
                </Col>
                <Col xs={24} md={10}>
                    <ProductCategorySelector
                        onChange={this.handleProductCategoryChange}
                        placeholder={i18n.t('orders:selectCategory')}
                        style={{ width: '100%' }}
                        value={inquiry.get('itemProductCategoryId')}
                    />
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = state => ({
    inquiry: state.get('inquiry')
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setSearchQuery,
        setItemQuery,
        setProductCategoryFilter
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('orders')(ItemFilters))
